import React, {Suspense, lazy} from 'react';
import {ROUTE_EFFORT_HYGIENE_REPORT} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import {Spin} from 'antd';

const EffortHygieneReport = lazy(() =>
  import('../../../screens/EffortHygieneReport')
    .then(module => ({default: module.EffortHygieneReport})));

const EffortHygieneReportNavigation = [
  {
    path: ROUTE_EFFORT_HYGIENE_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EffortHygieneReport />
      </Suspense>
    ),
  },
];

export default EffortHygieneReportNavigation;
